import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { ConfigService } from 'src/app/services/config.service';
import { AlertService } from '../../../pages/shared/alert/alert.service';
import { DataResolverService } from 'src/app/services/data-resolver.service';

export interface Environment {
    id: string | number;
    name?: string;
    environment?: string;
    email?: string;
    avatar?: string;
    initials?: string;
    isDefault?: boolean;
    account_title?: string | null | undefined;
    company_name?: string | null | undefined;
    user_role_name?: string | null | undefined;
    is_api_user?: boolean | null | undefined;
}

@Component({
    selector: 'app-environment-selection',
    templateUrl: './environment-selection.component.html',
    styleUrls: ['./environment-selection.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class EnvironmentSelectionComponent implements OnInit, OnDestroy {
    environments: Environment[] = [];
    isLoading = false;
    hoveredEnvironmentId: string | number | null = null;
    token: any;
    rememberMe: any = false;
    showLoader = false;
    openSearch = false;
    searchInputValue = '';
    allEnvironments: Environment[] = [];

    constructor(
        private service: ConfigService,
        private router: Router,
        private alert: AlertService,
        private dataResolverService: DataResolverService,
        private location: Location
    ) { }

    // Custom loader methods to match ngxLoader behavior
    startLoader() {
        this.showLoader = true;
    }

    stopLoader() {
        this.showLoader = false;
    }

    ngOnInit(): void {
        // Add body class to hide sidebar when component is active
        document.body.classList.add('environment-selection-active');
        this.loadEnvironments()
    }

    ngOnDestroy(): void {
        // Remove body class when component is destroyed
        document.body.classList.remove('environment-selection-active');
    }

    async loadEnvironments() {
        this.isLoading = true;
        // this.startLoader();

        // Update with your actual API path
        const response: any = await this.service.getApi('/api/users/accounts/list', '', "", 'auth_service');

        if (response && response.success && response.data) {
            console.log(response.data);
            this.allEnvironments = Array.isArray(response.data) ? response.data : response.data.environments || [];
            this.environments = [...this.allEnvironments];
        } else {
            this.alert.show(response.error.message, "error");
        }

        // this.stopLoader();
        this.isLoading = false;
    }

    async onEnvironmentClick(dataobj: any) {
        let response;
        this.startLoader();
        response = await this.service.postFormData(
            "/api/service_provider_access_account/" + dataobj?.id,
            dataobj?.id,
            "",
            "auth_service"
        );

        if (response?.data) {
            this.service.settoken(response.data.access_token);
            this.token = response.data.access_token;
            this.service.token = response.data.access_token;
            this.service.setuser(response.data);

            // this.alert.show(response.message, "success");

            // console.log(response.data);
            // console.log(JSON.stringify(response.data.permissions.formatted_permissions));
            // console.log(localStorage.getItem('permissions'));
            // return;

            localStorage.setItem("access_token", this.token);
            // localStorage.setItem('email', this.loginForm.controls['email'].value);
            // localStorage.setItem('password', this.loginForm.controls['password'].value);
            localStorage.setItem("rememberMe", this.rememberMe);
            if (this.rememberMe === true) {
                localStorage.setItem("rememberMe", "true");
            }
            if (this.rememberMe === false || this.rememberMe === undefined) {
                localStorage.setItem("rememberMe", "false");
            }
            if (response.data.account_type == "admin" || response.data.account_type == "company_account") {
                this.router.navigate(["account-management/company-account"]);
            } else {
                // await this.dataResolverService.resolve();
                this.router.navigate(["dashboard"]);
                // setTimeout(() => {
                //     window.location.reload();
                // }, 0);
            }
        } else {
            this.alert.show(response?.error.message, "error");
        }
        this.stopLoader();
    }


    onEnvironmentHover(environmentId: string | number | null) {
        this.hoveredEnvironmentId = environmentId;
    }

    getInitials(name: string): string {
        if (!name) return '';
        const parts = name.trim().split(' ');
        if (parts.length >= 2) {
            // Check if second word is a number
            const secondPart = parts[1];
            if (!isNaN(Number(secondPart)) && secondPart.trim() !== '') {
                // If second word is a number, only return first letter of first word
                return parts[0][0].toUpperCase();
            }
            // If second word is not a number, return first letter of both words
            return (parts[0][0] + parts[1][0]).toUpperCase();
        }
        return name.substring(0, 2).toUpperCase();
    }

    getAvatarColor(environment: Environment): string {
        // Fixed color for all avatar circles
        return 'rgba(236, 99, 82, 1)';
    }

    goBack() {
        this.location.back();
    }

    searchOption(type: string) {
        if (type === 'search') {
            this.openSearch = !this.openSearch;
            if (!this.openSearch) {
                this.searchInputValue = '';
                this.getGridData();
            }
        }else{
            this.openSearch = false;
            this.searchInputValue = '';
            this.getGridData();
        }
    }

    debounceSearch() {
        this.getGridData();
    }

    getGridData() {
        if (!this.searchInputValue) {
            this.environments = [...this.allEnvironments];
            return;
        }
        const searchValue = this.searchInputValue.toLowerCase().trim();
        this.environments = this.allEnvironments.filter(env => 
            (env.account_title || '').toLowerCase().includes(searchValue)
        );
    }
}

